/**
 * Company: SPHMedia
 * Description: [Shuffle button]
 */

import ShuffleIcon from "@assets/icons/refresh.svg";
import ShuffleIconBlue from "@assets/icons/refresh-blue.svg";
import cx from "classnames";
import { ReactElement } from "react";

type ShuffleButtonProps = {
  onShuffle: () => Promise<void>;
  variant?: "white" | "blue";
};

/**
 * ShuffleButton
 * Description: [Shuffle button for follow topic block]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function ShuffleButton({
  onShuffle,
  variant = "white",
}: ShuffleButtonProps): ReactElement {
  const isBlue = variant === "blue";

  const styles = {
    icon: !isBlue ? ShuffleIcon : ShuffleIconBlue,

    textStyle: cx(
      "text-xs leading-[120%]",
      !isBlue ? "text-white-200 font-semibold" : "text-blue-400 font-regular",
    ),
  };

  return (
    <button
      data-testid="shuffle-button"
      className="flex gap-1 justify-center items-center py-2 min-w-[120px]"
      onClick={() => {
        void onShuffle();
      }}
    >
      <img
        src={styles.icon}
        width={16}
        height={16}
        alt="refresh"
        data-testid="shuffle-icon"
      />
      <p className={styles.textStyle}>Susun semula</p>
    </button>
  );
}
